import React from "react";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();

  const handleNavigation = (path) => {
    navigate(path);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="bg-maroon-dark text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Logo & Social */}
          <div>
            <button
              onClick={() => handleNavigation("/")}
              className="text-2xl font-bold mb-4 block"
            >
              <img
                src="/ImageAndVideo/logo/withoutbg.png"
                alt="Logo"
                className=" w-40 object-cover"
              />
            </button>
            <p className="text-gray-300 mb-4">
              Compassionate care for every generation. Your trusted partner in
              elder care services.
            </p>
            {/* <div className="flex space-x-4">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gold hover:text-white transition-colors"
              >
                <i className="fab fa-facebook text-xl"></i>
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gold hover:text-white transition-colors"
              >
                <i className="fab fa-twitter text-xl"></i>
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gold hover:text-white transition-colors"
              >
                <i className="fab fa-linkedin text-xl"></i>
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gold hover:text-white transition-colors"
              >
                <i className="fab fa-instagram text-xl"></i>
              </a>
            </div> */}
          </div>

          {/* Quick Links */}
          <div>
            <h1 className="text-lg font-bold mb-4">Quick Links</h1>
            <ul className="space-y-2">
              {[
                { name: "Home", path: "/" },
                { name: "Services", path: "/services" },
                { name: "Membership", path: "/membership" },
                { name: "About Us", path: "/about" },
                { name: "Area Covered", path: "/partners" },
                { name: "Blog / Media / Events", path: "/blogs" },
                { name: "Testimonials", path: "/testimonials" },
                { name: "Book Consultancy", path: "/book-consultant" },
                { name: "Contact Us", path: "/contact" },
                { name: "Admin Login", path: "/admin/login" },
              ].map((link) => (
                <li key={link.name}>
                  <button
                    onClick={() => handleNavigation(link.path)}
                    className="text-white hover:text-gold transition-colors text-left w-full"
                  >
                    {link.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h1 className="text-lg font-bold mb-4">Services</h1>
            <ul className="space-y-2">
              {[
                "Remote Health Management",
                "At-Home Healthcare Services",
                "Tele-Medicine Connectivity",
                "Access to Specialists",
                "Trusted Homecare Support",
                "Emergency Services Access",
                "Reliable Service Network",
                "Remote Family Monitoring",
                "24/7 Support",
              ].map((service) => (
                <li key={service}>
                  <button
                    onClick={() => handleNavigation("/services")}
                    className="text-white hover:text-gold transition-colors text-left w-full"
                  >
                    {service}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h1 className="text-lg font-bold mb-4">Contact Info</h1>
            <ul className="space-y-2">
              <li className="text-gray-300">+91 98102 52031</li>
              <li className="text-gray-300">info@aegiscare.co.in</li>
              <li className="text-gray-300">
                12/78 Punjabi Bagh, New Delhi, 110026
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-600 mt-8 pt-8 text-center">
          <p className="text-gray-300">
            &copy; {new Date().getFullYear()} Aegiscare. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
